import * as actionTypes from "./actionTypes";

export const setBarMessage = (message) => {
    return {
        type: actionTypes.SET_BAR_MESSAGE,
        payload: { message },
    };
};

export const removeBarMessage = () => {
    return {
        type: actionTypes.REMOVE_BAR_MESSAGE,
    };
};
